import { render, staticRenderFns } from "./SubPlatformsEditor.vue?vue&type=template&id=cad33e38"
import script from "./SubPlatformsEditor.vue?vue&type=script&lang=js"
export * from "./SubPlatformsEditor.vue?vue&type=script&lang=js"
import style0 from "./SubPlatformsEditor.vue?vue&type=style&index=0&id=cad33e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports